<template>
    <span>
        <font-awesome-icon v-if="currentrouteNotHome===true" icon="chevron-left" size="lg" @click="goBack" id="backbutton"/>
    </span>
</template>
<script type="text/babel">
    export default {
        name: 'Backbutton',
        data() {
            return {
                currentroute: null,

            }
        },
        computed: {

            currentrouteNotHome() {

                return this.currentroute !== 'home';

            }
        },
        mounted() {
            this.$router.beforeEach((to, from, next) => {



                this.currentroute = to.name;

                next()
            })


        },


        methods: {
            goBack() {

                window.history.length > 1
                    ? this.$router.go(-1)
                    : this.$router.push('/')
            }
        }
    }
</script>

<style lang="scss" scoped>

    #backbutton {

        -webkit-appearance: none;
        border: none;


        color: #cad522;
        padding-left: 20px;
        padding-right: 10px;

    }

</style>